<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>MAKİNE FİLTRELEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">MAKİNE FİLTRELEME EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">MAKİNE FİLTRELEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label">Makine Seçiniz</label>
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>MAKİNE SEÇİNİZ</option>
                    <option v-for="makine in makineler" :value="makine.id" :key="makine.id">{{ makine.makina_code + " "
                    +
                    makine.makina_name}}</option>
                  </select>
                </div>


              </form>
            </div>
          </div>
          <button
          v-if="makinetemp"
          @click="pdfdownload(makine_id)"
          class="btn btn-info"
          type="button"
        >
          PDF İNDİR
        </button>
          <div class="row">
            <div class="col-md-12">
              <div class="tile">
                <div class="tile-body">
                  <table class="table table-hover table-bordered" id="sampleTable">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Makina</th>
                        <th>Delgi Adeti</th>
                        <th>Motor</th>
                        <th>Operatör</th>
                        <th>Açıklama Bir</th>
                        <th>Açıklama iki</th>
                        <th>Kullanıcı Adı</th>
                        <th>Belge Tarihi</th>
                        <th>Oluşturma Tarhi</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
import PersonelEkle from "./PersonelEkle.vue";
export default {
  data() {
    return {
      saha_idm: this.$route.query.idm,
      sahaname: "",
      makinetemp: "",
      makineler: [],
      cap_delgi: "",
      derinlik: "",
      fiyat_delgi: "",
      toplam_delgi: "",
      personelId: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);

    var url = store.state.base_url + "AslanSahalar/getAllSahaMakineler.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          saha_id: this.saha_idm.substr(0,3)
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
        this.makineler = response.data;
        console.log(this.makineler);
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    pdfdownload() {
      window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/index3.php?key=123&keyword=${this.saha_idm}&makine_id=${this.makinetemp}`, "_blank");
    },
    getBySaha(event) {
      var results = this.result;
      this.makinetemp = event.target.value;
      let url =
        store.state.base_url + "AslanSahalar/getByIdMakineDelgi.php?key=123";
      var datas2 = {
        
        makine_id: event.target.value,
        saha_id: this.saha_idm.substr(0,3),
      };

      axios
        .post(url, JSON.stringify(datas2))
        .then((response) => {
          datas2 = response.data;
          //    console.log(datas2);
          var table = $("#sampleTable").DataTable();
          $.each(datas2, function (index, value) {
            table.row
              .add([
                value["id"],
                value["makina"],
                value["delgiadeti"],
                value["motorbaslama"],
                value["operatorname"],
                value["aciklamaone"],
                value["aciklamatwo"],
                value["nameSurname"],
                value["date"],
                value["reg_date"],
              ])
              .draw(false);
          });

          $("#sampleTable tbody").on("click", "tr", function () {
            var data = table.row(this).data();
            results.id = data[0];
            window.location.href = "#/updatedelgi?id=" + results.id;
          });
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    reload: function () {
      location.reload();
    },
    sendData: function () {
      console.log(this.oprone);
      if (this.cap_delgi == "") {
        this.$swal({
          text: "DELGİ ÇAPINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.derinlik == "") {
        this.$swal({
          text: "DELGİ DERİNLİĞİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.fiyat_delgi == "") {
        this.$swal({
          text: "DELGİ BİRİM FİYATINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else if (this.toplam_delgi == "") {
        this.$swal({
          text: "TOPLAM DELGİ SAYISINI GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        var url = store.state.base_url + "AslanSahalar/updateSahaData.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          cap_delgi: this.cap_delgi,
          derinlik: this.derinlik,
          fiyat_delgi: this.fiyat_delgi,
          toplam_delgi: this.toplam_delgi,
          saha_id: this.saha_id
        };

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data == true) {
              this.$swal({
                text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              setTimeout(function () {
                location.reload();
              }, 1250);
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MakineFiltrele.vue